export const pcPath = {
  perfix: 'pc',
  login: 'login',
  menu: 'menu',
  order_management: 'odm',
  internal_management: 'inm',
  system_management: 'sym'
};

export const mobilePath = {
  perfix: 'mb',
  login: 'login',
  menu: 'menu', // 主選單
};

